/*    
<summary>
  This functional component "CheckAgreementPasswordPopupHOC" provides props to the child component.
  1. State "showAccountingPopup" that manages the show/hide of pop up
  2. Function "checkAgreementPasswordPopupToggleHandler" to toggle the show/hide popup state "showAccountingPopup"
  Developer:Aashish Singh, Created Date:29-August-2023
</summary>
<returns>Returns JSX</returns>
*/
import React, { useState } from "react";

const CheckAgreementPasswordPopupHOC = (Component: any) =>
  function Comp(props: any) {
    const [showCheckAgreementPasswordPopup, setShowCheckAgreementPasswordPopup] = useState<boolean>(false);

    const checkAgreementPasswordPopupToggleHandler = () => {
      setShowCheckAgreementPasswordPopup(!showCheckAgreementPasswordPopup);
    };

    return (
      <Component
        showCheckAgreementPasswordPopup={showCheckAgreementPasswordPopup}
        checkAgreementPasswordPopupToggleHandler={checkAgreementPasswordPopupToggleHandler}
        {...props}
      />
    );
  };

export default CheckAgreementPasswordPopupHOC;
